// extracted by mini-css-extract-plugin
module.exports = {"not-found-wrapper":"notification-m__not-found-wrapper__12CBn","en-wrapper":"notification-m__en-wrapper__3etq_","content":"notification-m__content__35yOq"};